export default __webpack_public_path__ + "static/media/banner4.b6e7483f.jpg";